import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Pay = ({ email, userId, onPaymentSuccess }) => {
  const [formData, setFormData] = useState({
    document: '',
    celular: '',
    valor: '',
    email,
    userId,
    tokenConfirm:''
  });
  // eslint-disable-next-line
  const [sessionFormData, setSessionFormData] = useState({
    sessionId: ''
  });
  
  const [message, setMessage] = useState('');
  const [isPaymentConfirmed, setIsPaymentConfirmed] = useState(false);
  //const [tokenConfirm, setTokenConfirm] = useState('');

  const navigate = useNavigate();

  

  useEffect(() => {
    return () => {
      setFormData({
        document: '',
        celular: '',
        valor: '',
        email,
        userId,
        tokenConfirm:''
      });
      setSessionFormData({ sessionId: '' });
    };
  }, [email, userId]);

  const handleChange = (e) => {
    if (e.target.name === 'sessionId') {
      setSessionFormData({ sessionId: userId });
    } else {
      setFormData(prevFormData => ({
        ...prevFormData,
        [e.target.name]: e.target.value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/user/pay-email`, formData);
      setMessage(response.data.message);
      setIsPaymentConfirmed(true);
    } catch (error) {
      setMessage(error.response ? error.response.data.message : 'Ocurrió un error al enviar el correo.');
    }
  };

  // const handleBack = () => {
  //   setMessage('');
  //   setFormData({
  //     document: '',
  //     celular: '',
  //     valor: '',
  //     email,
  //     userId
  //   });
  //   setSessionFormData({ sessionId: '' });
  //   setIsPaymentConfirmed(false);
  //   navigate('/'); // Redirigir a la página principal
  // };  

  const handleConfirmPayment = async () => {
    try {
      const response = await axios.post('http://localhost:4000/api/user/confirm-payment', {
        ...formData,
        sessionId: userId
      });
      setMessage(response.data.message);
      setTimeout(() => {
        onPaymentSuccess(); // Llama a la función para actualizar el balance
        navigate('/dashboard'); // Redirigir a la página principal
      }, 1000); // Muestra el mensaje por 3 segundos antes de redirigir
    } catch (error) {
      console.error('Ocurrió un error al confirmar el pago:', error.response ? error.response.data.message : 'Error desconocido');
      setMessage(error.response ? error.response.data.message : 'Error al confirmar el pago');
    }
  };

  return (
    <Container>
      {isPaymentConfirmed ? (
        <ConfirmationForm>
        <Text>Confirmación de Pago</Text>
        <InputWrapper>
        <Text>{formData.valor} USD</Text>

        </InputWrapper>
        <InputWrapper>
          <InputConfim
            type="text"
            name="tokenConfirm"
            defaultValue={formData.tokenConfirm}
            onChange={(e) => handleChange(e)}
            placeholder="Codigo de Confirmación"
            required
          />
        </InputWrapper>
        <Button onClick={handleConfirmPayment}>Confirmar Pago</Button>
        {message && <p style={{color: message.startsWith('Error') ? 'red' : 'green', marginTop: '20px'}}>{message}</p>}
      </ConfirmationForm>
      ) : (
        <FormContainer>
          <Text2>Pagar por Correo Electrónico</Text2>
          <Row>
            <Column>
            <InputContainer>
              <Label>Documento de Identidad:</Label>
              <Input
                type="text"
                name="document"
                value={formData.document}
                onChange={handleChange}
                placeholder="Número de documento"
                required
              />
            </InputContainer>
            <InputContainer>
              <Label>Celular:</Label>
              <Input
                type="tel"
                name="celular"
                value={formData.celular}
                onChange={handleChange}
                placeholder="Número de teléfono"
                required
              />
            </InputContainer>
            </Column>
            <Column>
            <InputContainer>
              <Label>Monto:</Label>
              <Input
                type="number"
                name="valor"
                value={formData.valor}
                onChange={handleChange}
                placeholder="0.00"
                required
              />
            </InputContainer>
            </Column>
          </Row>
          {message && <p style={{color: message.startsWith('Error') ? 'red' : 'green', marginTop: '20px'}}>{message}</p>}
          <ButtonContainer>
          {/* <Button onClick={handleBack} style={{marginRight: '10px'}}>Regresar</Button> */}
          <Button type="submit" onClick={handleSubmit}>Enviar</Button>
        </ButtonContainer>
     
        </FormContainer>
      )}
    </Container>
  );
};

// Estilos con styled-components
// const Container = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// Estilos con styled-components
const Container = styled.div`
  display: flex;
  justify-content: flex-start; // Cambia esto de 'center' a 'flex-start'
  align-items: center;
  //min-height: 100vh;
  margin-left: 200px; // Añade un padding a la izquierda
  width: 90%; // Añadimos width: 100%
`;

const Text2 = styled.h2`
  margin-top: 20px; // Aumentamos el margen superior
  margin-bottom: 50px; // Añadimos un margen inferior
  text-align: center; // Centramos el texto
`;

const Text = styled.h2`
  margin-top: 20px; // Aumentamos el margen superior
  margin-bottom: 15px; // Añadimos un margen inferior
  text-align: center; // Centramos el texto
`;

const FormContainer = styled.div`
  color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  background: linear-gradient(to bottom right, #333, #555);
`;

const Label = styled.label`
  margin-right: 10px;
  font-weight: bold;
  min-width: 120px; // Ajusta este valor según el ancho que desees para los labels
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: calc(50% - 20px);
`;

const Row = styled.div`
  display: flex;
  gap: 20px;
`;

const Input = styled.input`
  display: block;
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const InputConfim = styled.input`
  display: block;
  margin-bottom: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s ease;
  width: 100%;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const Button = styled.button`
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

const ConfirmationForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 0 auto;
    color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  background: linear-gradient(to bottom right, #333, #555);
`;

const InputWrapper = styled.div`
  width: 100%;
  max-width: 300px;
  margin-bottom: 20px;
`;

export default Pay;
